import { render, staticRenderFns } from "./TableButtonsWrapper.vue?vue&type=template&id=223d87fa"
import script from "./TableButtonsWrapper.vue?vue&type=script&lang=js"
export * from "./TableButtonsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports